import {DefaultTheme} from 'styled-components';

const theme: DefaultTheme = {
  borderRadius: '10px',

  colors: {
    main: '#FFFFFF',
    secondary: '#FFFFFF',
    background: '#F4F4F4',
    error: 'rgb(255,100,100)',
    success: 'rgb(10,238,20)',
    shadow: 'rgba(0,0,20,0.3)',
    fontLight: '#f0f5f5',
    fontDark: '#242626',
  },
  screenSize: {
    md: '768px',
  },
};

export {theme};
